import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AftermarketWidget from "./aftermarket-widget";
import CompatibilityWidget from "./compatibility-widget";
import PartsFinderWidget from "./parts-finder-widget";
import { OwnerManualsListWidget } from "./manuals-list-widget";
import { RequestQuoteWidget } from "./request-quite-widget";
import { SetWidget } from "./set-widget";
import { ExternalStockWidget } from "./external-stock-widget";
import { ReplacementsWidget } from "./replacements-widget";

export const renderExternalStockWidget = () => {
  const rootExternalStock = document.getElementById("externalStockRoot");
  if (!rootExternalStock) {
    return;
  }

  // Clear existing content first to handle re-renders with different params
  rootExternalStock.innerHTML = "";

  const permanentDomainExternalStock = rootExternalStock.getAttribute("data-domain");
  const skuExternalStock = rootExternalStock.getAttribute("data-sku");
  const country = rootExternalStock.getAttribute("data-country") || "EN";

  const ownStockStr = rootExternalStock.getAttribute("data-own-stock");
  const ownStock = ownStockStr ? parseInt(ownStockStr) : 0;

  const reactRootExternalStock = ReactDOM.createRoot(rootExternalStock);

  if (permanentDomainExternalStock && skuExternalStock && rootExternalStock) {
    console.log("renderExternalStockWidget inside");

    reactRootExternalStock.render(
      <React.StrictMode>
        <ExternalStockWidget permanentDomain={permanentDomainExternalStock} sku={skuExternalStock} country={country} ownStock={ownStock} />
      </React.StrictMode>
    );
  }

  return reactRootExternalStock;
};

const renderCompatibilityWidget = () => {
  const rootCompatibility = document.getElementById("compatibilityRoot");
  if (!rootCompatibility) {
    return;
  }
  const permanentDomainCompatibility = rootCompatibility.getAttribute("data-domain");
  const skuCompatibility = rootCompatibility.getAttribute("data-sku");
  const countryCode = rootCompatibility.getAttribute("data-country") || "EN";

  if (permanentDomainCompatibility && skuCompatibility && rootCompatibility) {
    const reactRoot = ReactDOM.createRoot(rootCompatibility);
    reactRoot.render(
      <React.StrictMode>
        <CompatibilityWidget permanentDomain={permanentDomainCompatibility} sku={skuCompatibility} countryCode={countryCode} />
      </React.StrictMode>
    );
  }
};

const renderAftermarketWidget = () => {
  const rootAftermarket = document.getElementById("aftermarketRoot");
  if (!rootAftermarket) {
    return;
  }

  const permanentDomainAftermarket = rootAftermarket.getAttribute("data-domain");
  const skuAftermarket = rootAftermarket.getAttribute("data-sku");
  const country = rootAftermarket.getAttribute("data-country") || "EN";

  if (permanentDomainAftermarket && skuAftermarket && rootAftermarket) {
    const reactRootAftermarket = ReactDOM.createRoot(rootAftermarket);

    reactRootAftermarket.render(
      <React.StrictMode>
        <AftermarketWidget permanentDomain={permanentDomainAftermarket} sku={skuAftermarket} country={country} />
      </React.StrictMode>
    );
  }
};

const renderPartsFinder = () => {
  const rootPartsFinder = document.getElementById("partsFinderRoot");
  if (!rootPartsFinder) {
    return;
  }

  const permanentDomainPartsFinder = rootPartsFinder.getAttribute("data-domain");
  const country = rootPartsFinder.getAttribute("data-country") || "EN";
  const forceBrand = rootPartsFinder.getAttribute("data-force-brand");

  if (permanentDomainPartsFinder && rootPartsFinder) {
    const reactRootPartsFinder = ReactDOM.createRoot(rootPartsFinder);

    reactRootPartsFinder.render(
      <React.StrictMode>
        <PartsFinderWidget permanentDomain={permanentDomainPartsFinder} country={country} forceBrand={forceBrand} />
      </React.StrictMode>
    );
  }
};

const renderOwnerManualsList = () => {
  const rootOwnerManualsList = document.getElementById("ownerManualsListRoot");
  if (!rootOwnerManualsList) {
    return;
  }

  const reactRootOwnerManualsList = ReactDOM.createRoot(rootOwnerManualsList);
  const permanentDomain = rootOwnerManualsList.getAttribute("data-domain") || "";

  reactRootOwnerManualsList.render(
    <React.StrictMode>
      <OwnerManualsListWidget permanentDomain={permanentDomain} />
    </React.StrictMode>
  );
};

const renderRequestQuote = () => {
  const rootRequestQuote = document.getElementById("rootRequestQuotePlaceholder");

  if (!rootRequestQuote) {
    return;
  }

  const sku = rootRequestQuote.getAttribute("data-sku") || "";
  const productTitle = rootRequestQuote.getAttribute("data-product-title") || "";

  if (!sku || !productTitle) {
    console.log("No sku or product title found");
    return;
  }

  const permanentDomain = rootRequestQuote.getAttribute("data-domain") || "";
  const countryCode = rootRequestQuote.getAttribute("data-country") || "EN";

  const renderer = ReactDOM.createRoot(rootRequestQuote);
  renderer.render(
    <React.StrictMode>
      <RequestQuoteWidget sku={sku} productTitle={productTitle} countryCode={countryCode} permanentDomain={permanentDomain} />
    </React.StrictMode>
  );
};

/**
 * @description Renders the set widget: which is a widget that shows how a SET OEM PART can be bought as seperate items if there is no stock for the set.
 * @returns {void}
 */
const renderSetWidget = () => {
  const rootSetWidget = document.getElementById("setWidgetRoot");
  if (!rootSetWidget) {
    return;
  }

  const sku = rootSetWidget.getAttribute("data-sku") || "";
  const permanentDomain = rootSetWidget.getAttribute("data-domain") || "";
  const country = rootSetWidget.getAttribute("data-country") || "";

  if (!sku || !permanentDomain || !country) {
    console.log("No sku, permanent domain or country found");
    return;
  }

  const reactRootSetWidget = ReactDOM.createRoot(rootSetWidget);
  reactRootSetWidget.render(
    <React.StrictMode>
      <SetWidget sku={sku} permanentDomain={permanentDomain} country={country} />
    </React.StrictMode>
  );
};

const renderReplacementsWidget = () => {
  const rootReplacements = document.getElementById("replacementsRoot");
  if (!rootReplacements) {
    return;
  }

  const permanentDomainReplacements = rootReplacements.getAttribute("data-domain");
  const skuReplacements = rootReplacements.getAttribute("data-sku");
  const country = rootReplacements.getAttribute("data-country") || "EN";

  if (permanentDomainReplacements && skuReplacements && rootReplacements) {
    const reactRootReplacements = ReactDOM.createRoot(rootReplacements);

    reactRootReplacements.render(
      <React.StrictMode>
        <ReplacementsWidget permanentDomain={permanentDomainReplacements} sku={skuReplacements} country={country} />
      </React.StrictMode>
    );
  }
};

renderCompatibilityWidget();
renderAftermarketWidget();
renderPartsFinder();
renderOwnerManualsList();
renderRequestQuote();
renderSetWidget();
renderReplacementsWidget();

const reactRootExternalStock = renderExternalStockWidget();

// Listen for changes to the externalStockRoot div and rerender
const observeExternalStockRoot = () => {
  const rootExternalStock = document.getElementById("externalStockRoot");
  if (!rootExternalStock) {
    return;
  }

  // Create a MutationObserver to watch for attribute changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes") {
        console.log("External stock root attributes changed, rerendering...");

        // Get the new sku from the attribute
        const newSku = rootExternalStock.getAttribute("data-sku");
        const newPermanentDomain = rootExternalStock.getAttribute("data-domain");
        const newCountry = rootExternalStock.getAttribute("data-country");
        const newOwnStock = rootExternalStock.getAttribute("data-own-stock");

        reactRootExternalStock.render(
          <React.StrictMode>
            <ExternalStockWidget permanentDomain={newPermanentDomain} sku={newSku} country={newCountry} ownStock={newOwnStock} />
          </React.StrictMode>
        );
      }
    });
  });

  // Start observing attribute changes
  observer.observe(rootExternalStock, {
    attributes: true,
    attributeFilter: ["data-sku", "data-own-stock", "data-domain", "data-country"],
  });
};

observeExternalStockRoot();
